export default __webpack_public_path__ + "fonts/9ef74b71f1fe3bf82899f5630df807fa.svg";